import React, { useState, useEffect } from "react";
import axios from "axios";
import HomeSingleBlog from '../../../components/HomeSingleBlog/HomeSingleBlog';
import { Link } from 'react-router-dom';

const LATEST_COUNT = 2;

const HomeBlogs = () => {

   const [newsUpdates, setNewsUpdates] = useState([]);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(null);

   const removeHtmlTags = (htmlContent) => {
      return htmlContent.replace(/<\/?[^>]+(>|$)/g, "");
   };

   useEffect(() => {
      const fetchNewsUpdates = async () => {
         try {
            const response = await axios.get(
               `${process.env.REACT_APP_API_URL}/blogs/`
            );

            const cleanedData = response.data.slice(0, LATEST_COUNT).map((item) => ({
               ...item,
               content: removeHtmlTags(item.content || ""),
            }));
            setNewsUpdates(cleanedData);
         } catch (err) {
            console.error("Failed to fetch news updates:", err);
            setError(err.message);
         } finally {
            setLoading(false);
         }
      };

      fetchNewsUpdates();
   }, []);

   if (!loading && !error && newsUpdates.length === 0) {
      return null;
   }

   return (
      <>
         <section className="home-news pt-100 pb-60">
            <div className="tw-container tw-mx-auto">
               <div className="home-news__header tw-text-center">
                  <span className="home-news__badge">Insights</span>
                  <h2 className="home-news__heading">Our Latest Insights</h2>
                  {/* <p className="home-news__subtitle">Practical guidance, technical deep-dives, and behind-the-scenes lessons from the team building your next digital product.</p> */}
               </div>
               {loading ? (
                  <div className="tw-flex tw-flex-wrap tw--mx-3">
                     {Array.from({ length: LATEST_COUNT }).map((_, i) => (
                        <div key={i} className="tw-w-full tw-px-3 md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
                           <div className="home-news__card home-news__skeleton tw-animate-pulse">
                              <div className="home-news__skeleton-image"></div>
                              <div className="home-news__card-body">
                                 <div className="tw-h-4 tw-w-16 tw-bg-gray-200 tw-rounded tw-mb-6 tw-ml-auto"></div>
                                 <div className="tw-mt-auto">
                                    <div className="tw-h-5 tw-w-full tw-bg-gray-200 tw-rounded tw-mb-2"></div>
                                    <div className="tw-h-5 tw-w-3/4 tw-bg-gray-200 tw-rounded"></div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     ))}
                  </div>
               ) : error ? (
                  <p className="tw-text-center">Unable to load the latest posts right now. Please check back soon.</p>
               ) : (
                  <div className="tw-flex tw-flex-wrap tw--mx-3">
                     {newsUpdates.map((news) => (
                        <HomeSingleBlog key={news.id} id={news.id} image={news.image} title={news.title} />
                     ))}
                  </div>
               )}
               <div className="tw-text-center">
                  <Link to="/blogs" className="home-news__more-btn">More Insights</Link>
               </div>
            </div>
         </section>
      </>
   );
};

export default HomeBlogs;
